<template>
  <div class="main">
    <div
      class="header"
      :style="{
        'background-color': '#2187FF',
      }"
    >
      <!-- <div
      class="header"
      :style="{
        'background-color':
          cityDetail.cityName == '华龙区' ? '#6680ea' : '#2187FF',
      }"
    > -->
      <span
        style="
          font-size: 18px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          width: 1704px;
          margin: 0 auto;
        "
        >HI,欢迎来到河南省
        {{
          deptName +
          (cityDetail.homeTitle
            ? cityDetail.homeTitle
            : "农村集体财产监督管理平台")
        }}！</span
      >
    </div>

    <div
      class="container"
      :style="{
        background: cityDetail.loginImg
          ? `url('${cityDetail.loginImg}') no-repeat`
          : `url('${require('../assets/img/loginbackground.png')}') no-repeat`,
        'background-size': '100% 100%',
      }"
    >
      <div
        style="
          width: 80%;
          margin: auto;
          height: 100%;
          display: flex;
          justify-content: space-between;
        "
      >
        <div class="left">
          <span class="titleImg">
            {{
              deptName +
              (cityDetail.homeTitle
                ? cityDetail.homeTitle
                : "农村集体财产监督管理平台")
            }}</span
          >
          <div class="input">
            <div class="typeDiv">
              <span @click="changeType(1)" :class="type == 1 ? 'span' : ''"
                >找资讯</span
              >
              <span style="width: 4px">|</span>
              <span @click="changeType(2)" :class="type == 2 ? 'span' : ''"
                >找项目</span
              >
            </div>

            <input
              type="text"
              placeholder="请输入关键字..."
              style="
                height: 50px;
                width: 58%;
                font-size: 18px;
                line-height: 50px;
              "
              v-model="keyword"
              @keyup.enter="toQuanzhan()"
            />
            <img
              src="../assets/img/loginSearch.png"
              style="height: 100%"
              @click="toQuanzhan"
            />
          </div>
          <div class="options">
            <span style="color: #ffffff; font-size: 18px; font-weight: 500"
              >热门搜索:</span
            >
            <span class="option" @click="searchkey('公示公告')">公示公告</span>
            <span class="option" @click="searchkey('交易项目')">交易项目</span>
            <span class="option" @click="searchkey('交易金额')">交易金额</span>
            <span class="option" @click="searchkey('报名须知')">报名须知</span>
          </div>
        </div>
        <div class="right">
          <div
            style="text-align: center; width: 100%; height: 74px"
            :style="{
              'background-color': '#2187FF',
            }"
          >
            <!-- <div
            style="text-align: center; width: 100%; height: 74px"
            :style="{
              'background-color':
                cityDetail.cityName == '华龙区' ? '#6680ea' : '#2187FF',
            }"
          > -->
            <span
              style="
                font-size: 30px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
                line-height: 74px;
              "
              >个人用户登录</span
            >
          </div>
          <div class="loginWindow">
            <div
              style="
                background-color: #ffffff;
                padding: 16px 20px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                border: 1px solid #c0c4cc;
                margin-bottom: 30px;
              "
            >
              <img
                src="../assets/img/loginusername.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                type="text"
                placeholder="请输入手机号"
                style="flex: 1; font-size: 20px; width: 100%"
                v-model="username"
              />
              <!-- <el-button
                type="primary"
                style="padding: 8px 6px"
                @click="getPhoneCode"
                :disabled="loginSec != 0"
                >获取验证码<span v-if="loginSec != 0"
                  >({{ loginSec }})</span
                ></el-button
              > -->
            </div>
            <div
              style="
                background-color: #ffffff;
                padding: 16px 20px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                border: 1px solid #c0c4cc;
                margin-bottom: 20px;
              "
            >
              <img
                src="../assets/img/loginpassword.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                :type="showPassword ? 'text' : 'password'"
                placeholder="请输入登录密码"
                style="flex: 1; font-size: 20px; width: 100%"
                v-model="password"
              />
              <img
                v-if="showPassword"
                src="../assets/img/closeEye.png"
                style="width: 20px; cursor: pointer; margin-left: 6px"
                @click="showPassword = !showPassword"
              />
              <img
                v-else
                src="../assets/img/openEye.png"
                alt=""
                style="width: 20px; cursor: pointer; margin-left: 6px"
                @click="showPassword = !showPassword"
              />
            </div>
            <!-- <div
              style="
                background-color: #ffffff;
                padding: 16px 20px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                border: 1px solid #c0c4cc;
                margin-bottom: 30px;
              "
            >
              <img
                src="../assets/img/loginpassword.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                placeholder="请输入验证码"
                style="flex: 1; font-size: 20px; width: 100%"
                v-model="code"
              />
            </div> -->
            <div
              @click="login"
              style="
                width: 100%;
                height: 60px;
                justify-content: center;
                display: flex;
                cursor: pointer;
              "
              :style="{
                'background-color': '#2187FF',
              }"
            >
              <!-- <div
              @click="login"
              style="
                width: 100%;
                height: 60px;
                justify-content: center;
                display: flex;
                cursor: pointer;
              "
              :style="{
                'background-color':
                  cityDetail.cityName == '华龙区' ? '#6680ea' : '#2187FF',
              }"
            > -->
              <span
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                  font-weight: 500;
                  color: #ffffff;
                  line-height: 60px;
                  margin-bottom: 56px;
                  user-select: none;
                "
                >登 录</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <span
                  @click="$router.push('/')"
                  style="
                    font-size: 16px;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #474b52;
                    cursor: pointer;
                  "
                  >返回</span
                >
              </div>
              <div>
                <router-link
                  to="/register"
                  style="
                    font-size: 16px;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #2187ff;
                  "
                  >立即注册</router-link
                >
                <span
                  style="font-size: 16px; display: inline-block; margin: 0 10px"
                  >|</span
                ><a
                  style="
                    font-size: 16px;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #2187ff;
                    cursor: pointer;
                  "
                  @click="setPassword()"
                  >忘记密码</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <yqlj></yqlj> -->
    <SCFoot v-if="cityDetail.cityName == '上蔡县'" />
    <!-- <HLQFoot v-else-if="cityDetail.cityName == '华龙区'" /> -->
    <Foot v-else />
    <el-dialog
      class="passwordDialog"
      :visible.sync="isShow"
      width="800px"
      center
      title="找回密码"
      style="zoom: 1.25"
    >
      <div class="steps" style="display: flex; justify-content: center">
        <!-- 
                    <el-step title="修改密码"></el-step> -->
        <el-steps :active="active" finish-status="success" style="width: 300px">
          <el-step title="验证信息"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </div>

      <div class="formView">
        <div class="formInput" v-if="active == 0">
          <p>电话号码：</p>
          <input
            placeholder="请输入电话号码"
            placeholder-class="placeholder"
            type="text"
            v-model="form.phone"
          />
        </div>

        <div class="formInput" v-if="active == 0">
          <p>新密码：</p>
          <input
            placeholder="请输入新密码"
            placeholder-class="placeholder"
            :type="showNewPassword ? 'text' : 'password'"
            v-model="form.newPassword"
            @input="newPasswordChange"
          />
          <img
            v-if="showNewPassword"
            src="../assets/img/closeEye.png"
            style="width: 20px; cursor: pointer; margin-left: 6px"
            @click="showNewPassword = !showNewPassword"
          />
          <img
            v-else
            src="../assets/img/openEye.png"
            alt=""
            style="width: 20px; cursor: pointer; margin-left: 6px"
            @click="showNewPassword = !showNewPassword"
          />
          <span class="showNewPasswordMessage" v-if="showNewPasswordMessage"
            >密码中必须包含大小写字母、数字、特殊字符,长度在8到20位之间。</span
          >
        </div>
        <div class="formInput" v-if="active == 0">
          <p>验证码：</p>
          <input
            placeholder="请输入验证码"
            placeholder-class="placeholder"
            type="text"
            v-model="form.code"
          />
          <div class="btn" v-show="isSend" @click="sendCode">获取验证码</div>
          <div class="btn1" v-show="!isSend">重新获取({{ sec }})</div>
        </div>

        <div class="tip" v-if="active == 3">修改成功！</div>
      </div>

      <div class="button" @click="next">
        {{ active < 2 ? "下一步" : "关闭" }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import yqlj from '@/components/Home/Third/友情链接1.vue'
import Foot from '@/components/Foot.vue'
import SCFoot from '@/components/SCFoot'
import HLQFoot from '@/components/HLQFoot'
import {
  login,
  sendEmail,
  checkEmailCode,
  emailUpdatePassword,
  getPhoneCode,
  phoneUpdatePassword,
} from '../api/login.js'
import { cityDetail } from '../util/mainOption.js'
export default {
  components: {
    yqlj,
    Foot,
    SCFoot,
    HLQFoot,
  },
  data () {
    return {
      username: '',
      code: "",
      uuid: '',
      loginSec: 0,
      password: '',
      keyword: '',
      type: 1,
      path: null,
      isShow: false,
      active: 0, //步骤
      form: {
        phone: '',
        code: '',
        newPassword: '',
      },
      isSend: true,
      sec: 60,
      showPassword: false,
      showNewPasswordMessage: false,
      showNewPassword: false,
      deptName: "",
    }
  },
  created () {
    this.path = this.$route.query.path ? this.$route.query.path : null
  },
  methods: {
    getPhoneCode () {
      getPhoneCode(this.username)
        .then((res) => {
          this.$message.success(res.data.msg)
          this.uuid = res.data.uuid
          this.loginSec = 60
          let timer = setInterval(() => {
            if (this.loginSec == 0) {
              clearInterval(timer)
            } else {
              this.loginSec--
            }

          }, 1000)
        })
        .catch((err) => {
        })
    },
    changeType (i) {
      this.type = i
    },
    toQuanzhan () {
      if (this.keyword.trim() != '') {
        this.$router.push({
          name: '全站搜索',
          query: { keyword: this.keyword, type: this.type },
        })
      } else {
        this.$message.error('查询关键字不可为空')
      }
    },
    searchkey (key) {
      this.$router.push({ name: '全站搜索', query: { keyword: key, type: 1 } })
    },
    login () {
      if (this.username.trim() == '') {
        this.$message.error('手机号不可为空')
      }
      // else if (this.code.trim() == '') {
      //   this.$message.error('验证码不可为空')
      // } 
      else if (this.password.trim() == '') {
        this.$message.error('密码不可为空')
      }
      else {

        login({
          username: this.username,
          password: this.password,
          areaId: this.cityDetail.lesseeId,
          loginType: 0,
        }).then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.$message.success('登录成功')
            // this.$router.push('/')
            this.$router.push('/')
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('phone', this.username)
            this.$cookie.set('status', 'login')
            this.$cookie.set('phone', this.username)
            console.log(this.$emit("initWebSocket"))
          } else {
            this.$message.error(res.data.msg)
          }
        })
        // login({
        //   code: this.code,
        //   phone: this.username,
        //   username: this.username,
        //   areaId: this.cityDetail.lesseeId,
        //   loginType: 1,
        //   uuid: this.uuid,
        // }).then((res) => {
        //   console.log(res)
        //   if (res.data.code == 200) {
        //     this.$message.success('登录成功')
        //     // this.$router.push('/')
        //     this.$router.push('/')
        //     localStorage.setItem('token', res.data.token)
        //     localStorage.setItem('phone', this.username)
        //     this.$cookie.set('status', 'login')
        //     this.$cookie.set('phone', this.username)
        //   } else {
        //     this.$message.error(res.data.msg)
        //   }
        // })
      }
    },
    // 忘记密码
    setPassword () {
      this.isShow = true
    },
    newPasswordChange () {
      let regex = new RegExp(
        '(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}'
      )
      if (!regex.test(this.form.newPassword)) {
        this.showNewPasswordMessage = true
      } else {
        this.showNewPasswordMessage = false
      }
    },
    next () {
      console.log(this.active)
      let testEmail = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/
      let regex = new RegExp(
        '(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}'
      )
      if (this.active == 0) {
        if (!this.form.phone) {
          this.$message.warning('请输电话号码')
          return
        } else if (this.form.phone && !testEmail.test(this.form.phone)) {
          this.$message.warning('请输入正确的电话号码')
          return
        } else if (!this.form.code) {
          this.$message.warning('请输入验证码')
          return
        } else if (!regex.test(this.form.newPassword)) {
          return
        } else {
          // checkEmailCode(this.form).then(res => {
          //     console.log(res.data);
          //     this.$message.success(res.data.msg)

          // })
          phoneUpdatePassword(this.form).then((res) => {
            this.$message.success(res.data.msg)
            this.active += 3
          })
        }
      } else if (this.active == 1) {
        if (!this.form.phone) {
          this.$message.warning('请输入电话号码')
          return
        } else if (this.form.phone && !testEmail.test(this.form.phone)) {
          this.$message.warning('请输入正确的电话号码')
          return
        } else if (!this.form.newPassword) {
          this.$message.warning('请输入新密码')
          return
        } else {
          // emailUpdatePassword(this.form).then(res => {
          //     this.active++
          //     this.active++
          //     this.$message.success(res.data.msg)
          // })
        }
      } else {
        this.form.phone = ''
        this.form.code = ''
        this.form.newPassword = ''
        this.active = 0
        this.isShow = false
      }
    },
    // 发送电话号验证码
    sendCode () {
      let testEmail = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/

      // console.log(this.form.phone)
      if (!this.form.phone) {
        this.$message.warning('请输入电话号码')
        return
      } else if (this.form.phone && !testEmail.test(this.form.phone)) {
        this.$message.warning('请输入正确的电话号码')
        return
      } else {
        this.timeJian()
        getPhoneCode(this.form.phone)
          .then((res) => {
            this.$message.success(res.data.msg)
            this.form.uuid = res.data.uuid
          })
          .catch((err) => {
            this.isSend = false
          })
      }
    },
    // 发送验证码倒计时
    timeJian () {
      if (this.sec == 0) {
        this.isSend = true
        this.sec = 60
        return false
      } else {
        this.isSend = false
        this.sec--
      }
      setTimeout(() => {
        this.timeJian()
      }, 1000)
    },
  },
  mounted () {
    this.deptName = cityDetail.toCityChangeTitle ? (sessionStorage.getItem("deptName") ? sessionStorage.getItem("deptName") : cityDetail.cityName) : cityDetail.cityName
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

input {
  border: none;
  outline: none;
}

.main {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  height: 52px;
  width: 100%;
  zoom: 1.2;
  box-sizing: border-box;
  padding-left: 240px;
}

.container {
  width: 100%;
  background-size: 100% 100%;
  height: 946px !important;
  zoom: 1.1;
}

.left {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  margin-left: 140px;
  zoom: 1.2;
}

.titleImg {
  font-family: Source Han Sans;
  font-size: 50px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 24px;
  text-shadow: 1px 1px 1px #919191, 1px 2px 1px #919191, 1px 3px 1px #919191,
    1px 4px 1px #919191, 1px 5px 1px #919191, 1px 12px 6px rgba(10, 10, 10, 0.4),
    1px 14px 6px rgba(10, 10, 10, 0.2), 1px 16px 10px rgba(10, 10, 10, 0.2),
    1px 18px 35px rgba(10, 10, 10, 0.2), 1px 20px 60px rgba(10, 10, 10, 0.2);
}

.input {
  display: flex;
  align-items: center;
  background-color: #fff;
  width: 699.5px;
  padding-right: 0;
  border-radius: 5px;
}

.options {
  display: flex;
  align-items: center;
  height: 24px;
  font-size: 18px;
}

.option {
  margin-left: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}

.right {
  display: flex;
  flex-direction: column;
  margin-top: 160px;
  width: 460px;
  zoom: 1.2;
}

.loginWindow {
  background: url("../assets/img/loginfog.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
  padding: 30px 40px;
}

.typeDiv {
  width: 200px;
  height: 50px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
}

.typeDiv span {
  font-size: 20px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #3c3c3c;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
}

.typeDiv .span {
  font-size: 20px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #2187ff;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.passwordDialog >>> .el-dialog__header {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.steps {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 70px;
}

.button {
  width: 90%;
  height: 50px;
  text-align: center;
  font-size: 18px;
  line-height: 50px;
  background-color: #2187ff;
  color: #fff;
  margin: 0 auto;
  border-radius: 50px;
  cursor: pointer;
}

.formView {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 46px 50px 46px;
  margin: 0 auto;
  height: auto;
  /* overflow: hidden; */
  background-color: #ffffff;
}

.formInput {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.formInput p {
  width: 100px;
  height: 30px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #333333;
  text-align: justify;
  text-justify: inter-word;
}

.formInput input {
  flex: 1;
  height: 40px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: #333333;
  box-sizing: border-box;
  padding-left: 30px;
}
.formInput > .showNewPasswordMessage {
  position: absolute;
  top: 70%;
  left: 20%;
  font-size: 12px;
  color: #f00;
  user-select: none;
}
.formInput .placeholder {
  color: #999999;
}

.formInput .btn {
  width: 170px;
  height: 44px;
  border: 1px solid #369eff;
  opacity: 1;
  border-radius: 50px;
  font-size: 20px;
  font-family: PingFang-SC-Medium;
  line-height: 44px;
  text-align: center;
  color: #369eff;
  cursor: pointer;
}

.formInput .btn1 {
  width: 170px;
  height: 44px;
  opacity: 1;
  border-radius: 50px;
  font-size: 20px;
  font-family: PingFang-SC-Medium;
  line-height: 44px;
  text-align: center;
  background-color: #757575;
  color: #ffffff;
  cursor: pointer;
}

.tip {
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 30px;
  text-align: center;
  color: #369eff;
}
</style>
